import React from "react"

function SidebarSection({ children }) {
  return <div className="menu_section">{children}</div>
}

export default SidebarSection
